import React from "react";
import "./serviceSection.styles";
import DescriptionIcon from "@mui/icons-material/Description";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import { useNavigate } from "react-router-dom";

const servicesData = [
  {
    icon: <DescriptionIcon className="service-icon" />,
    title: "Resume & Profile Building",
    description:
      "Your resume is your first impression — let’s make it unforgettable. We’ll craft a job-ready, ATS-optimized resume that highlights your real strengths and skills.",
  },
  {
    icon: <TrendingUpIcon className="service-icon" />,
    title: "Career Guidance & Roadmap",
    description:
      "Confused about where to start? I’ll personally guide you with a clear, step-by-step career path tailored to your goals and background.",
  },
  {
    icon: <WorkOutlineIcon className="service-icon" />,
    title: "Job & Internship Assistance",
    description:
      "Get connected to genuine job and internship opportunities through our trusted network. We don’t stop until you get your first offer — that’s a promise.",
  },
  {
    icon: <QuestionAnswerIcon className="service-icon" />,
    title: "Interview Preparation Mastery",
    description:
      "From mock interviews to real-time feedback, we’ll prepare you to face any HR or technical round with full confidence and clarity.",
  },
  {
    icon: <ConnectWithoutContactIcon className="service-icon" />,
    title: "HR Connect & Placement Network",
    description:
      "Gain direct access to our exclusive HR network and placement partners. We bridge the gap between your talent and the right recruiters.",
  },
  {
    icon: <LinkedInIcon className="service-icon" />,
    title: "LinkedIn Profile Optimization",
    description:
      "Turn your LinkedIn into a professional magnet. We help you build a profile that gets noticed, builds credibility, and attracts recruiters.",
  },
  {
    icon: <SmartToyIcon className="service-icon" />,
    title: "AI Tools for Career Growth",
    description:
      "Learn how to use modern AI tools to enhance productivity, prepare smarter, and stand out from other candidates in today’s tech-driven job market.",
  },
  {
    icon: <RecordVoiceOverIcon className="service-icon" />,
    title: "Power Skills & Communication Coaching",
    description:
      "Develop the essential skills that define success — from confidence and communication to problem-solving and teamwork.",
  },
];

const ServiceSection = () => {

   const navigate = useNavigate();

   const handleNavigate = () => {
     navigate("/services"); // 👈 this navigates to the Services page
   };

  return (
    <section className="services-section">
      <div className="services-content">
        <h2 className="services-heading">Our Services</h2>
        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon-wrapper">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
        <button className="view-all-btn" onClick={handleNavigate}>
          View All Services
        </button>
      </div>
    </section>
  );
};

export default ServiceSection;
